import historyProvider from '../datafeed/historyProvider'
import $store from '@/store/index'
import Data from '@/util/data'
import Stream from '../datafeed/stream'
import Util from '@/util/util'

const supportedResolutions = [
  '1',
  '5',
  '15',
  '30',
  '60',
  '240',
  '360',
  'D',
  'W',
  'M'
]

const config = {
  supported_resolutions: supportedResolutions
  // supports_marks: true,
  // supports_timescale_marks: true
}

const GStream = new Stream('G')

export default {
  onReady: cb => {
    // console.log('=====onReady running')
    setTimeout(() => cb(config), 0)
  },
  searchSymbols: (userInput, exchange, symbolType, onResultReadyCallback) => {
    // console.log('====Search Symbols running', userInput, exchange, symbolType)

    const res = $store.state.data.symbolsTV.filter(pair => {
      // console.log(pair)
      return pair.full_name.toUpperCase().includes(userInput)
    })

    onResultReadyCallback(res)
  },
  resolveSymbol: (
    symbolName,
    onSymbolResolvedCallback,
    onResolveErrorCallback
  ) => {
    // console.log('======resolveSymbol running', symbolName)
    const splitData = symbolName.split(/[:/]/)
    const symb1 = splitData[1] + '_' + splitData[2]
    let priceDec = 8
    if (splitData[0] === 'BIF') {
      priceDec = 2
    } else {
      if ($store.state.data.symbolsfilter[symb1]) {
        priceDec = $store.state.data.symbolsfilter[symb1].PriceDec
      } else if (symb1 === 'BTC_USDT' || symb1 === 'ETH_USDT') {
        priceDec = 2
      }
    }

    // expects a symbolInfo object in response
    // console.log('======resolveSymbol running')
    // console.log('resolveSymbol:', symbolName, symb1)
    // console.log('priceDec:', priceDec)

    // console.log({split_data})
    const symbolStub = {
      // name: symbolName,
      name: splitData[1] + '/' + splitData[2],
      // pro_name: splitData[1] + '/' + splitData[2],
      // full_name: splitData[0] + ':' + splitData[1] + '/' + splitData[2],
      description: splitData[1] + '/' + splitData[2],
      type: 'crypto',
      session: '24x7',
      timezone: 'Etc/UTC',
      ticker: splitData[0] + ':' + splitData[1] + '/' + splitData[2],
      exchange: splitData[0],
      minmov: 1,
      pricescale: Math.pow(10, priceDec),
      has_intraday: true,
      intraday_multipliers: ['1', '5', '15', '30', '60', '240', '360'],
      supported_resolution: supportedResolutions,
      supports_time: true,
      has_daily: true,
      has_weekly_and_monthly: true,
      volume_precision: 8,
      data_status: 'streaming'
    }

    setTimeout(function () {
      // console.log('symbol resolved:', symbolStub)
      onSymbolResolvedCallback(symbolStub)
    }, 0)

    // onResolveErrorCallback('Not feeling it today')
  },
  getBars: function (
    symbolInfo,
    resolution,
    periodParams,
    onHistoryCallback,
    onErrorCallback
  ) {
    const { from, to, firstDataRequest } = periodParams
    // console.log('=====getBars running. interval:', resolution, ' from:', new Date(from * 1000), ' to:', new Date(to * 1000), ' first:', firstDataRequest)
    // console.log('ft', from, to)
    // console.log(`Requesting bars between ${new Date(from * 1000).toISOString()} and ${new Date(to * 1000).toISOString()}`)
    historyProvider
      .getBars('grid', symbolInfo, resolution, from * 1000, to * 1000, firstDataRequest)
      .then(bars => {
        if (bars.length) {
          onHistoryCallback(bars, { noData: false })
        } else {
          onHistoryCallback(bars, { noData: true })
        }
      })
      .catch(err => {
        console.log(err)
        onErrorCallback(err)
      })
  },
  subscribeBars: (symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback) => {
    Data.resetCacheBot = onResetCacheNeededCallback
    GStream.subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback)
    // stream.subscribeBars(symbolInfo, resolution, onRealtimeCallback, subscribeUID, onResetCacheNeededCallback)
  },
  unsubscribeBars: subscriberUID => {
    // console.log('=====unsubscribeBars running')
    GStream.unsubscribeBars(subscriberUID)
    // stream.unsubscribeBars(subscriberUID)
  },
  calculateHistoryDepth: (resolution, resolutionBack, intervalBack) => {
    return historyProvider.historyDepth(resolution, resolutionBack, intervalBack)
  },
  getMarks: (symbolInfo, startDate, endDate, onDataCallback, resolution) => {
    // optional
    // console.log('=====getMarks running', endDate)

    // var mark = {
    //   id: '12345',
    //   time: (endDate - 900000),
    //   color: 'red',
    //   text: 'hello',
    //   label: 'B',
    //   labelFontColor: 'black',
    //   minSize: 10
    // }

    // onDataCallback([mark])
  },
  getTimeScaleMarks: (
    symbolInfo,
    startDate,
    endDate,
    onDataCallback,
    resolution
  ) => {
    // optional
    // console.log('=====getTimeScaleMarks running')

    // var mark = {
    //   id: '12345',
    //   time: endDate,
    //   color: 'red',
    //   text: 'hello',
    //   label: 'B',
    //   labelFontColor: 'black',
    //   minSize: 5
    // }

    // onDataCallback([mark])
  },
  getServerTime: cb => {
    setTimeout(() => cb(Math.floor(Date.now() / 1000)))
  }
}
